import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { useTranslation } from 'react-i18next'

import { formatMoney } from '../../../helpers/helpers'

const StatusPill = ({ id, status, refundedAmount }) => {
  const { t } = useTranslation(['attendees'])
  const formattedRefundedAmount = refundedAmount ? formatMoney(refundedAmount) : ''
  return (
    <>
      <div
        className={`attendee_status-pill attendee_status-pill--${status.value}`}
        data-tip
        data-for={`${id}-event-refunded-status-pill`}
      >
        {status.label}
      </div>
      {refundedAmount > 0 && (
        <ReactTooltip id={`${id}-event-refunded-status-pill`} effect="solid">
          {t('attendees:refundedAmount', { amount: formattedRefundedAmount })}
        </ReactTooltip>
      )}
    </>
  )
}

StatusPill.propTypes = {
  id: PropTypes.string,
  status: PropTypes.object,
}

export default StatusPill
